import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";

import ContentBlock from "@/components/wpl/content-block/src";
import { OneLinkProps } from "@/components/wpl/content-block/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";

const containerStyle = css({
    alignItems: "stretch",
    background: "#1868DB",
    fontFamily: "var(--bxp-charlie-display-font-family)",
    letterSpacing: "0.3px",
    margin: "-40px 0 0 0",
    display: "flex",
    flexDirection: "row",
    textAlign: "center",
    maxWidth: "1169px"
});

const contentContainerStyles = css({
    "color": "#FFF",
    "paddingBlockStart": "18px",
    "paddingBlockEnd": "18px",
    "marginInlineStart": "auto",
    "marginInlineEnd": "auto",
    "width": "100%",

    [media.below.md]: {
        width: "736px",
        paddingBlockStart: "30px",
        paddingBlockEnd: "30px",
        paddingInlineStart: "42px"
    },
    [media.below.sm]: {
        width: "300px"
    },
    [media.below.xs]: {
        width: "auto",
        height: "unset",
        marginInlineStart: "25px",
        marginInlineEnd: "25px",
        paddingBlockStart: "25px",
        paddingBlockEnd: "25px",
        paddingInlineStart: "0px"
    },

    ".content-block": {
        alignItems: "center !important"
    },

    "h3": {
        fontSize: "32.519px",
        fontStyle: "normal",
        fontWeight: "700",
        marginBlockEnd: "4px !important",
        textAlign: "center !important",
        width: "550px",

        [media.below.md]: {
            marginBlockEnd: "14px !important",
            textAlign: "left !important",
            fontSize: "32px",
            fontWeight: "700",
            lineHeight: "38px" /* 118.75% */,
            width: "330px"
        },
        [media.below.sm]: {
            width: "250px"
        },
        [media.below.xs]: {
            width: "unset",
            fontSize: "28px",
            lineHeight: "32px",
            textAlign: "center !important"
        }
    },

    "p": {
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: "300 !important",
        lineHeight: "24px",
        marginBlockEnd: "10px !important",
        textAlign: "center !important",

        [media.below.md]: {
            marginBlockEnd: "14px !important",
            textAlign: "left !important",
            fontSize: "16px",
            fontWeight: "400",
            width: "330px"
        },
        [media.below.sm]: {
            width: "250px"
        },
        [media.below.xs]: {
            width: "unset",
            textAlign: "center !important"
        }
    },

    "a": {
        margin: "0 !important",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "24px"
    },

    ".contentBlock-Body": {
        marginBlockEnd: "0px !important"
    },

    ".contentBlock-linkFlex": {
        marginBlockEnd: "0px !important",
        justifyContent: "center !important",

        [media.below.md]: {
            justifyContent: "left !important"
        },
        [media.below.xs]: {
            justifyContent: "center !important"
        }
    }
});

const leftAccentStyle = css({
    flexBasis: "45%",
    background:
        "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-banner-building-left.webp) bottom left / contain no-repeat",

    [media.below.md]: {
        display: "none",
        flexBasis: "0"
    }
});

const rightAccentStyle = css({
    flexBasis: "45%",
    background:
        "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-banner-building-right-desktop.webp) bottom right / contain no-repeat",

    [media.below.md]: {
        flexBasis: "100%"
    },
    [media.below.xs]: {
        display: "none"
    }
});

export const CompetitiveBlitzBanner = () => {
    const intl = useIntl();

    const headerText = intl.formatMessage({
        id: "CompetitiveBlitzBanner.CtaSection.Header",
        defaultMessage: "There’s a new leader in ITSM software"
    });
    const descriptionText = intl.formatMessage({
        id: "CompetitiveBlitzBanner.CtaSection.Description",
        defaultMessage:
            "See why companies are switching to Jira Service Management"
    });
    const ctaText = intl.formatMessage({
        id: "CompetitiveBlitzBanner.CtaSection.LinkText",
        defaultMessage: "Compare ITSM solutions"
    });

    const primaryLinkProps: OneLinkProps = {
        primaryLinkProps: {
            text: ctaText,
            href: useLocalizedHref(
                "/software/jira/service-management/comparison"
            ),
            className: "jiraLinkStyling",
            dataEventProps: {
                "data-product-key": "jiraServiceManagement",
                "data-event": "clicked",
                "data-event-container": "ctaSection",
                "data-event-component": "link"
            },
            customLinkColor: "#FFF"
        }
    };

    return (
        <Row layout="12" alignItems="center">
            <div css={containerStyle}>
                <div css={leftAccentStyle} />
                <div css={contentContainerStyles}>
                    <ContentBlock
                        headerText={headerText}
                        bodyText={descriptionText}
                        ctaProps={primaryLinkProps}
                    />
                </div>
                <div css={rightAccentStyle} />
            </div>
        </Row>
    );
};
